/* eslint-disable react/jsx-one-expression-per-line */
import { ChevronRight } from '@mui/icons-material'
import classNames from 'classnames'
import { appealStatus } from 'feature/appeals/helpers/appealStatus'
import { TGetConsultationResponse } from 'feature/appeals/type'
import { convertDataToStringWithMonth } from 'helpers/date/convertDataToStringWithMonth'
import { Button, Chip } from 'ui'

import { FeedBackBlock } from '../FeedBackBlock/FeedBackBlock'

import style from './ConsultationCard.module.scss'
import { ConsultationInformation } from './ConsultationInformation/ConsultationInformation'

type TConsultationCard = {
  data: TGetConsultationResponse
}
//карточка консультации
export const ConsultationCard = ({ data }: TConsultationCard) => {
  const { status } = data
  const isGradeBlockVisible =
    (data.canGrade && data.grade.link) || data.grade.value > 0
  const statusName = status.name.charAt(0).toUpperCase() + status.name.slice(1)
  return (
    <>
      <Button
        // @ts-ignore
        to='/appeals'
        variant='text'
        className={style.backButton}
        color='primary'
        startIcon={
          <ChevronRight
            color='primary'
            className={classNames('rotate180', style.chevronRight)}
          />
        }
        data-testid='consultation-card-back'
      >
        Назад
      </Button>

      <div className={style.header}>
        <div className={style.headerLeft}>
          <div className={classNames(style.appealName, 'h1')}>
            {`обращение от ${convertDataToStringWithMonth(
              data.date,
              false,
              false,
            )}`}
          </div>
          <div className={style.appealInf}>
            <div className={style.appealInfItem}>
              <span className='caption'>{`Номер обращения ${data.id}`}</span>
              <div className={style.status}>
                <Chip status={appealStatus(status.status)} label={statusName} />
              </div>

              <div className={style.content}>
                <ConsultationInformation data={data} />

                {isGradeBlockVisible && (
                  <>
                    <div className={style.line}></div>
                    <FeedBackBlock
                      grade={data.grade}
                      canGrade={data.canGrade}
                      writeFeedbackText='Оцените оказанную Вам услугу'
                      yourFeedbackText='Ваша оценка'
                      writeFeedbackBtnText='Оставить отзыв'
                      yourFeedbackBtnText='Смотреть отзыв полностью'
                      feedbackModalTitle='Отзыв об услуге'
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
